
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/customer-loyalty-program",
      function () {
        return require("private-next-pages/features/customer-loyalty-program.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/customer-loyalty-program"])
      });
    }
  